import { render, staticRenderFns } from "./TalkFile.vue?vue&type=template&id=58b60c2a&scoped=true"
import script from "./TalkFile.vue?vue&type=script&lang=js"
export * from "./TalkFile.vue?vue&type=script&lang=js"
import style0 from "./TalkFile.vue?vue&type=style&index=0&id=58b60c2a&prod&lang=stylus&scoped=true"
import style1 from "./TalkFile.vue?vue&type=style&index=1&id=58b60c2a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b60c2a",
  null
  
)

export default component.exports